import { updateWireDisbursementAsync } from 'API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: updateWireDisbursementSlice, asyncAction: updateWireDisbursementAction } = createAsyncSlice(
  'updateWireDisbursementSlice',
  updateWireDisbursementAsync
);
